module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/store_images/1@2x_bb257ec3f6a99f86055d06487b0f49ea.png";